__turbopack_context__.v({
  "bottomNote": "AhVMVa_bottomNote",
  "noteSeparator": "AhVMVa_noteSeparator",
  "root": "AhVMVa_root",
});
